import { Container } from "@mui/material";
import { BusquedaProyectos } from "../../componentes/BuquedaProyectos";

export const BusqProyectoPage:React.FC<{}> =() =>{
    return(
        <Container sx={{mt:4}}>
            <BusquedaProyectos />
        </Container>
    );
}